export default __webpack_public_path__ + "static/media/skrapWeb.a2c330e9.jpg";